<template>
  <a-modal
    :visible="visible"
    :destroy-on-close="true"
    @cancel="$emit('close')"
    @ok="handleUpdateCourse"
  >
    <h3>Edit course</h3>

    <a-form layout="horizontal">
      <a-form-item
        :label-col="{ span: 8 }"
        :wrapper-col="{ span: 16 }"
        :validate-status="errors.first('title') ? 'error' : ''"
        :help="errors.first('title')"
        label="Title"
      >
        <a-input
          v-model="updatedCourse.title"
          v-validate="'required|max:255'"
          placeholder="Course title"
          data-vv-name="title"
        />
      </a-form-item>

      <a-form-item
        :label-col="{ span: 8 }"
        :wrapper-col="{ span: 16 }"
        :validate-status="errors.first('description') ? 'error' : ''"
        :help="errors.first('description')"
        label="Description"
      >
        <a-textarea
          v-model="updatedCourse.description"
          v-validate="'required'"
          :auto-size="{ minRows: 3 }"
          data-vv-name="description"
          placeholder="Description of Course"
        />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script setup lang="ts">
import { ref, watch, getCurrentInstance } from "vue";
import useMixin from "@/useMixin";

// Props
const props = defineProps({
  course: { type: Object, default: undefined },
  visible: { type: Boolean, default: false },
});

// Emits
const emits = defineEmits(["update-course", "close"]);

// Mixins
const { setObject } = useMixin();

// Watchers
watch(
  () => props.visible,
  (newProp, oldProp) => {
    if (newProp && !oldProp) {
      updatedCourse.value = setObject(updatedCourse.value, props.course);
    }
  }
);

// Data Properties
const updatedCourse = ref<any>({
  id: undefined,
  title: undefined,
  description: undefined,
});

// Class Methods
const instance = getCurrentInstance();
const $validator = instance?.proxy.$validator;
const handleUpdateCourse = (): void => {
  $validator?.validateAll().then((result) => {
    if (result) {
      emits("update-course", updatedCourse.value);
      emits("close");
    }
  });
};
</script>
